<template>
    <div>
        <div class="group_skills_popup" @click="close"></div>
        <div class="main">
            <span class="title">拼团小技巧</span>
            <p class="txt1">分享到3个家长群，</p>
            <p class="txt2">拼团<span>成功率高达 95%</span></p>
            <button @click="share">继续分享</button>
        </div>        
    </div>

</template>

<script>
export default {
  name: "group_skills_popup",
  props: {
    // headList: Array,
  },
  components: {},
  created: function() {},
  methods: {
    share() {
      this.$emit("share");
    },
    close() {
      this.$emit("close");
    }
  }
};
</script>

<style lang="scss" scoped>
.group_skills_popup {
  position: fixed;
  width: 100%;
  height: 100vh;
  background: rgba($color: #000000, $alpha: 0.5);
  top: 0;
  left: 0;
}
.main {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 4.74rem;
  background-color: #ffffff;
  border-radius: 0.4rem 0.4rem 0rem 0rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  .title {
    font-family: PingFangSC-Medium;
    font-size: 0.34rem;
    font-weight: normal;
    font-stretch: normal;
    line-height: 0.29rem;
    letter-spacing: 0px;
    color: #919294;
    margin-top: 0.44rem;
    position: relative;
    &::before {
      position: absolute;
      content: "";
      width: 0.14rem;
      height: 0.03rem;
      background-color: #dcdde0;
      left: -0.3rem;
      top: 0.14rem;
    }
    &::after {
      position: absolute;
      content: "";
      width: 0.14rem;
      height: 0.03rem;
      background-color: #dcdde0;
      right: -0.3rem;
      top: 0.14rem;
    }
  }
  p {
    font-family: PingFangSC-Medium;
    font-size: 0.34rem;
    font-weight: normal;
    font-stretch: normal;
    line-height: 0.34rem;
    letter-spacing: 0px;
    color: #5f6162;
  }
  .txt1 {
    margin-top: 0.66rem;
  }
  .txt2 {
    margin-top: 0.23rem;
    span {
      color: #ff7171;
    }
  }
  button {
    width: 6rem;
    height: 1rem;
    background-color: #37df72;
    border-radius: 0.5rem;
    margin-top: 0.69rem;
    font-family: PingFangSC-Medium;
    font-size: 0.34rem;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    color: #ffffff;
  }
}
</style>